<aside
  class="fixed inset-y-0 left-0 z-30 flex h-screen w-64 flex-col bg-blue-900 text-white transition-transform duration-300 md:relative md:translate-x-0"
  [class.-translate-x-full]="!open()"
  [class.translate-x-0]="open()"
>
  <!-- Logo -->
  <div class="p-6 border-b border-blue-800">
    <div class="flex items-center justify-between">
      <div class="flex items-center space-x-3">
        <img src="gota_avatar.webp" alt="SGCAP" class="w-12 h-12 rounded-full">
        <div>
          <h1 class="text-xl font-bold">SGCAP</h1>
          <p class="text-xs text-blue-300">Inventario</p>
        </div>
      </div>
      <!-- Cerrar en mobile -->
      <button
        type="button"
        class="md:hidden text-blue-300 hover:text-white p-1"
        (click)="closeRequest.emit()"
        aria-label="Cerrar menú"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Menú -->
  <nav class="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
    @for (item of menuItems(); track $index) {
      <a
        routerLink="{{ item.route }}"
        routerLinkActive="bg-blue-800"
        class="flex items-center space-x-3 px-4 py-3 rounded-lg hover:bg-blue-800 transition cursor-pointer"
        (click)="closeRequest.emit()"
      >
        <i [class]="item.icon + ' w-5'"></i>
        <span>{{ item.label }}</span>
      </a>
    }
  </nav>

  <!-- Versión -->
  <div class="px-4 pb-1 text-center">
    <span class="text-xs text-blue-400">v{{ appVersion }}</span>
  </div>

  <!-- Usuario -->
  <div class="p-4 border-t border-blue-800">
    <div class="flex items-center space-x-3">
      <div class="w-10 h-10 rounded-full bg-blue-700 flex items-center justify-center shrink-0">
        <i class="fas fa-user"></i>
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-sm font-medium truncate">{{ usuarioResource.value() ?? 'Cargando...' }}</p>
      </div>
      <button
        type="button"
        (click)="logout()"
        class="text-blue-300 hover:text-white shrink-0"
        aria-label="Cerrar sesión"
      >
        <i class="fas fa-sign-out-alt"></i>
      </button>
    </div>
  </div>
</aside>
